import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import {
  IPagedSection,
  IPagingContext,
} from "Components/Layout/PageComponent/PageDataProvider"
import Link from "Components/Link"
import { IPublic } from "data/contentData/interfaces/mongodb/IPublic"
import React from "react"
import { t } from "translations"

export default function ToC({
  page,
  paging,
}: {
  page: IPublic
  paging: IPagingContext | null
}) {
  let sections: IPagedSection[] = paging?.pages ?? []
  const leadSection = page.sections?.find((p) => p.type === "root")

  // Merge root section with first section if paginateLeadText === false
  sections = page.paginateLeadText
    ? page.sections?.map((section) => {
        return section.type === "root"
          ? {
              ...section,
              name: page.title,
              url: page.url,
              isCurrent: false,
            }
          : { ...section, isCurrent: false }
      }) ?? []
    : page.sections
        ?.filter((p) => p.type !== "root")
        .map((section, index) => {
          const _section =
            index === 0 && leadSection
              ? {
                  ...section,
                  leadText: leadSection.blockContent,
                  isCurrent: false,
                }
              : {
                  ...section,
                  isCurrent: false,
                }
          return _section
        }) ?? []

  if (!sections?.length) return null

  return (
    <StyledToC>
      <Typography variant="body1" fontWeight={700}>
        {t.article.tocTitle}
      </Typography>
      <StyledListWrapper aria-label={t.article.tocTitle}>
        <StyledList>
          {sections.map((section) => (
            <StyledListItem key={section.url} color="inherit">
              <StyledLink variant="body2" href={`#${section.url}`}>
                {section.name}
              </StyledLink>
            </StyledListItem>
          ))}
        </StyledList>
      </StyledListWrapper>
    </StyledToC>
  )
}

const StyledToC = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.secondary[100],
}))

const StyledListWrapper = styled("nav")(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}))

const StyledList = styled("ol")(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  listStylePosition: "outside",
  fontSize: "1rem",
  paddingInlineStart: 0,
  columnCount: 1,
  [theme.breakpoints.up("md")]: {
    columnCount: 2,
  },
}))

const StyledListItem = styled("li")(({ theme }) => ({
  padding: theme.spacing(1),
  maxWidth: 300,
  textOverflow: "ellipsis",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
}))

const StyledLink = styled(Link)(() => ({
  fontFamily: "inherit",
  "&:hover": {
    textDecoration: "none",
  },
}))
